import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Box, Button, Divider, Drawer, Typography } from '@mui/material';

import { NoraButton, Spacer } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { MIBCodebacks } from '../MIBCodebacks';
import { RequiredFieldErrorBar } from '../RequiredFieldErrorBar';
import styles from '../styles.module.scss';

const REVIEW_CODEBACK_BUTTON_NAME = 'codeback-drawer-review-button';

export const EditCodebacks = ({
  isOpen,
  setIsOpen,
  setIsReview,
  mibCodes,
  setMibCodes,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setIsReview: Dispatch<SetStateAction<boolean>>;
  mibCodes: string[];
  setMibCodes: Dispatch<SetStateAction<string[]>>;
}) => {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    // If the drawer is closed and then re-opened, the error bar should re-set
    setShowError(false);
  }, [isOpen]);

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">
            {Resource.TASK_TITLE_ORDER_MIB_CODEBACK}
          </Typography>
          <Button onClick={() => setIsOpen(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              Close
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          {showError && (
            <>
              <RequiredFieldErrorBar />
              <Spacer height={8} />
            </>
          )}
          <MIBCodebacks
            value={mibCodes}
            onChange={setMibCodes}
            label={Resource.MIB_CODES}
            required={true}
          />
        </Box>
        <Box>
          <NoraButton
            name={REVIEW_CODEBACK_BUTTON_NAME}
            className={styles.DrawerButton}
            onClick={() => {
              if (mibCodes && mibCodes.length > 0) {
                setIsReview(true);
              } else {
                setShowError(true);
              }
            }}
          >
            Review MIB Codes
          </NoraButton>
        </Box>
      </Box>
    </Drawer>
  );
};
